import EventHook from './EventHook'
import Logger from '../Log'

const Log = Logger.for('HookRunner')

export default class HookRunner {
  constructor () {
    this._hooks = {} // type: [hooks]
  }

  register (hook) {
    if (!(hook instanceof EventHook)) {
      throw Error('Hook was not an EventHook')
    }
    const h = this._hooks
    if (!h[hook.type()]) {
      h[hook.type()] = []
    }

    h[hook.type()].push(hook)
    Log.debug('Registered event hook ' + hook.name())
  }

  /**
   * Overload this with all arguments
   * e.g. run('START', bid, slot, media..)
   * We will forward all args to the hook method
   * @param type
   * @param allOtherArgsHere
   * @returns {Promise<unknown[]>|Promise<void>}
   */
  run (type, ...args) {
    const hooks = this._hooks[type]
    if (!hooks || !hooks.length) {
      Log.debug('No hooks for event ' + type + ' found, moving on')
      return Promise.resolve()
    }

    Log.debug('Running hooks for event ' + type)

    const promises = []
    for (const hook of hooks) {
      let to = null
      let fin = false
      const prom = hook.run(...args)
        .then(() => {
          if (fin) {
            Log.warn('Dang, hook ' + hook.name() + ' completed behind schedule')
            return
          }

          clearTimeout(to)
          Log.debug(hook.name() + ' hook completed')
        })
        .catch(e => {
          Log.error('Uncaught error in hook ' + hook.name() + ': ' + e)
          console.error(e)
        })

      // Create a new promise wrapping the hook as well as its own
      // timer. will complete when either one fires first
      const pto = Promise.race([prom, new Promise((resolve, reject) => {
        to = setTimeout(() => {
          Log.warn('Hook ' + hook.name() + ' not complete after 1 second!')
          fin = true
        }, 1000)
      })])

      promises.push(pto)
    }

    return Promise.all(promises)
  }
}
